export default "__VITE_ASSET__hnjoj8Cy__"